import React from "react";
import { FormControl, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";

const Field = ({ title, caption, value, classes }) => (
  <FormControl fullWidth className={classes.formControl}>
    <Typography variant="body2" className={classes.title}>
      {title}
    </Typography>
    <Typography variant="caption">{caption}</Typography>
    {React.isValidElement(value) ? (
      value
    ) : (
      <Typography variant="body1">{value}</Typography>
    )}
  </FormControl>
);

Field.defaultProps = {
  caption: "",
  value: "",
};

Field.propTypes = {
  title: PropTypes.string.isRequired,
  caption: PropTypes.string,
  value: PropTypes.node,
  classes: PropTypes.object,
};

const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
  title: {
    fontWeight: "bold",
  },
});

export default withStyles(styles)(Field);
